import * as actionTypes from './actionTypes';
import { serviceHTTP } from '../util/service';
import { store } from '../store/configureStore';
import * as spinnerActions from '../actions/spinnerActions';
import { getAccessToken, clearSessionData } from '../util/customMethods';
export const authenticateUser = (userName, password, success, fail) => {
  return (dispatch) => {
    dispatch(spinnerActions.showSpinner());
    return serviceHTTP.authenticate(userName, password)
      .then(response => {
        if (response.error === undefined) {
          response.isAuthenticated = true;
          response.userId = userName;
          dispatch(
            {
              type: actionTypes.AUTHENTICATE_USER,
              authInfo: response
            });

          dispatch(spinnerActions.hideSpinner());
          success();
        } else {
          response.isAuthenticated = false;
          response.userId = '';
          dispatch(
            {
              type: actionTypes.AUTHENTICATE_USER,
              authInfo: response
            });
          dispatch(spinnerActions.hideSpinner());
          fail();
        }
      })
      .catch(error => {
        dispatch(spinnerActions.hideSpinner());
        throw (error);
      });
  };
};
export const resetPassword = (userName, newPwd, secToken, success, fail) => {
  return (dispatch) => {
    dispatch(spinnerActions.showSpinner());
    return serviceHTTP.post('resetPassword', {
      "newPassword": newPwd,
      "userId": userName,
      "forgetToken": secToken,
    }, undefined, secToken)
      .then(response => {
        dispatch(spinnerActions.hideSpinner());
        success(response);
      })
      .catch(error => {
        dispatch(spinnerActions.hideSpinner());
        fail(error);
        throw (error);
      });
  }
}
export const forgetPassword = (userName, success, fail) => {
  return (dispatch) => {
    dispatch(spinnerActions.showSpinner());
    return serviceHTTP.post('recoverVendorUserPassword', {
      "emailId": userName,
      "forgetOption": "forgetPass"
    }, undefined, undefined)
      .then(response => {
        dispatch(spinnerActions.hideSpinner());
        success(response);
      })
      .catch(error => {
        dispatch(spinnerActions.hideSpinner());
        fail(error);
        throw (error);
      });
  }
}
export const isAuthenticated = () => {
  if (Object.keys((store.getState()).authInfo).length > 0) {
    return (store.getState()).authInfo.isAuthenticated
  } else {
    return false;
  }

}
export const logoutUser = (success, fail) => {
  let url = 'userLogout?access_token=' + getAccessToken()
  return (dispatch) => {
    dispatch(spinnerActions.showSpinner());
    return serviceHTTP.get(url, undefined, undefined)
      .then(response => {
        dispatch(spinnerActions.hideSpinner());
        dispatch(clearSessionData());
        success();
      })
      .catch(error => {
        dispatch(spinnerActions.hideSpinner());
        dispatch(clearSessionData());
        fail(error);
        throw (error);
      });
  }
}
// Add these MFA-related actions

export const checkEmailDomain = (email, success, fail) => {
  return (dispatch) => {
    dispatch(spinnerActions.showSpinner());
    return serviceHTTP.post('vendorMfa/checkEmailDomain', {
      "email": email
    }, undefined, undefined)
      .then(response => {
        dispatch(spinnerActions.hideSpinner());
        if (response && 
          (response.statusCode === 200)) {
          success(response);
        } else {
          fail(response);
        }
      })
      .catch(error => {
        dispatch(spinnerActions.hideSpinner());
        fail(error);
        throw (error);
      });
  }
}

export const generateOtp = (email, success, fail) => {
  return (dispatch) => {
    console.log("Generating OTP for email:", email);
    dispatch(spinnerActions.showSpinner());
    
    return serviceHTTP.post('vendorMfa/generateOtp', {
      "email": email
    }, undefined, undefined)
      .then(response => {
        console.log("OTP generation response:", response);
        dispatch(spinnerActions.hideSpinner());
        
        // The issue might be here - check what properties actually exist in your response
        // Add this debugging line:
        console.log("Response properties:", Object.keys(response));
        
        // More flexible condition that handles various response formats
        if (response && 
            (response.status === "OK" || 
             response.statusCode === 200 || 
             response.status === 200)) {
          success(response);
        } else {
          fail(response || { statusMsg: "Failed to generate OTP" });
        }
      })
      .catch(error => {
        console.error("OTP generation error:", error);
        dispatch(spinnerActions.hideSpinner());
        fail(error || { statusMsg: "Network error occurred" });
      });
  }
}
export const verifyOtp = (email, otp, success, fail) => {
  return (dispatch) => {
    console.log("Verifying OTP for email:", email, "OTP:", otp);
    dispatch(spinnerActions.showSpinner());
    
    return serviceHTTP.post('mfaLogin', {
      "email": email,
      "otp": otp
    }, undefined, undefined)
      .then(response => {
        console.log("MFA login response:", response);
        dispatch(spinnerActions.hideSpinner());
        
        if (response && response.success === "true") {
          // Same format as regular login response
          response.isAuthenticated = true;
          dispatch({
            type: actionTypes.AUTHENTICATE_USER,
            authInfo: response
          });
          
          success(response);
        } else {
          fail(response);
        }
      })
      .catch(error => {
        console.error("MFA verification error:", error);
        dispatch(spinnerActions.hideSpinner());
        fail(error);
      });
  }
}